import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { ShieldCheck, ArrowUpRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import lhgLogo from "@/assets/brand/lhg_mark_color.png";

export default function AdminLogin() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  useEffect(() => {
    if (location.state?.error) toast.error(location.state.error);
  }, [location.state]);

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-blue grain flex items-center justify-center px-6">
      <div
        data-testid="admin-login-card"
        className="relative w-full max-w-md bg-cream p-10 md:p-12 border border-amber/30"
      >
        <img src={lhgLogo} alt="Logan Hunter Group" className="h-16 w-auto object-contain mb-8" />
        <p className="eyebrow text-amber-deep text-[0.6rem] mb-3 flex items-center gap-2">
          <ShieldCheck size={14} /> Private Dashboard
        </p>
        <h1 className="font-serif font-bold text-4xl text-blue leading-tight">
          Owner access <span className="italic text-amber-deep">only.</span>
        </h1>
        <p className="font-body text-charcoal/70 mt-4 leading-relaxed">
          Sign in with your Google account to view leads and manage insights. Access is restricted
          to authorized addresses.
        </p>
        <button
          data-testid="google-signin-btn"
          onClick={signIn}
          className="group relative overflow-hidden w-full bg-blue text-cream px-8 py-4 eyebrow text-xs flex items-center justify-center gap-2 mt-9"
        >
          <span className="relative z-10 flex items-center gap-2">
            Continue with Google <ArrowUpRight size={16} />
          </span>
          <span className="absolute inset-0 bg-amber-deep translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)]" />
        </button>
      </div>
    </div>
  );
}
